import { ApiEndpointService } from 'app/core/services/api-endpoint.service';
import { MockHttpInterceptor } from 'app/mocks/http-mock.interceptor';
import { IMockRegistry } from 'app/mocks/interfaces/mock-registry.interface';

export type MockFactory = (
    apiEndpointService: ApiEndpointService,
    interceptor?: MockHttpInterceptor,
) => IMockRegistry;

export const mockRegistryFactories: MockFactory[] = [
    // environment.feature.claims.messenger ? mockClaimConversationMetadata : null,
    // environment.feature.claims.messenger ? mockClaimConversation : null,
    // environment.feature.claims.messenger ? mockCreateMessage : null,
    // environment.feature.claims.messenger ? mockUpdateMessage : null,
    // environment.feature.claims.messenger ? mockSyncConversation : null,
].filter(Boolean);
